/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    param1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    param2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    param3?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    param4?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    dOMAIN?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    dIGEST?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    vECTOR?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    firstPage?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    tranID?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    pointFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    targetPage?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    value2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    value3?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse
     */
    apiMemberId?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'param1': !exists(json, 'param1') ? undefined : json['param1'],
        'param2': !exists(json, 'param2') ? undefined : json['param2'],
        'param3': !exists(json, 'param3') ? undefined : json['param3'],
        'param4': !exists(json, 'param4') ? undefined : json['param4'],
        'dOMAIN': !exists(json, 'DOMAIN') ? undefined : json['DOMAIN'],
        'dIGEST': !exists(json, 'DIGEST') ? undefined : json['DIGEST'],
        'vECTOR': !exists(json, 'VECTOR') ? undefined : json['VECTOR'],
        'firstPage': !exists(json, 'first_page') ? undefined : json['first_page'],
        'tranID': !exists(json, 'TranID') ? undefined : json['TranID'],
        'pointFlag': !exists(json, 'point_flag') ? undefined : json['point_flag'],
        'targetPage': !exists(json, 'target_page') ? undefined : json['target_page'],
        'value': !exists(json, 'Value') ? undefined : json['Value'],
        'value2': !exists(json, 'value2') ? undefined : json['value2'],
        'value3': !exists(json, 'Value3') ? undefined : json['Value3'],
        'apiMemberId': !exists(json, 'apiMemberId') ? undefined : json['apiMemberId'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseExternalPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalUrl': value.externalUrl,
        'domain': value.domain,
        'param1': value.param1,
        'param2': value.param2,
        'param3': value.param3,
        'param4': value.param4,
        'DOMAIN': value.dOMAIN,
        'DIGEST': value.dIGEST,
        'VECTOR': value.vECTOR,
        'first_page': value.firstPage,
        'TranID': value.tranID,
        'point_flag': value.pointFlag,
        'target_page': value.targetPage,
        'Value': value.value,
        'value2': value.value2,
        'Value3': value.value3,
        'apiMemberId': value.apiMemberId,
    };
}

